module.exports = "img/flags/FJ.b7f1d1e.png";